import React, { useEffect } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { getSpecializations, getRequests, removeRequestsList, getCertificationPeriods } from '../../actions/common'
import { getOrganizations } from '../../actions/auth'
import Loader from '../../components/Loader'
import { NavLink, useNavigate } from 'react-router-dom'
import { Col } from 'react-bootstrap'
import Button from '../../components/Button'
import { BACKEND_DOMAIN } from '../../assets/const'
import { FaFilePdf } from "react-icons/fa";
import {RequestForm, RequestsTable, Reports, ReportsGUK} from './Components'
import { getDaysToCommission } from '../../utils/smallHelpers'



export default function Expert() {
  
  const { specializations, requestsList, certificationPeriods, loading } = useSelector(state => state.common)
  const { organizations, expert, edu_expert, guk, org } = useSelector(state => state.auth)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  useEffect(() => {
    !specializations && dispatch(getSpecializations())
    !certificationPeriods && dispatch(getCertificationPeriods())
    !organizations && dispatch(getOrganizations())
  }, [])

  const getRequestsList = (filters) => {
    dispatch(getRequests(filters))
  }
  
  const openRequest = (requestData) => () => {
    navigate(`/request/${requestData.id}`)
  }

  const sharedFilesClick = () => {
    navigate(`/shared_files`)
  }

  const getInstructionHandler = () => {
    const link = document.createElement('a')
    const fileName = guk ? 'ГУК.pdf' : edu_expert ? 'Руковдство пользователя Комиссия ОО.pdf' : 'ЭКСПЕРТЫ.pdf' 
    link.setAttribute('href', `${BACKEND_DOMAIN || ''}/help/${fileName}`)
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener noreferrer')
    link.click()
  }

  const daysToCommission = getDaysToCommission(certificationPeriods)

  return (
    <div className={styles.container}>
      <Col className={styles.butttonsBlock}>
        <Button label={"Методическая копилка"} onClick={sharedFilesClick}/>
        {(expert || guk) && <Reports/>}
        {guk && <ReportsGUK/>}
        {guk &&
          <NavLink to='/constructor'>
            <Button label='Конструктор'/>
          </NavLink>
        }
        <Button onClick={getInstructionHandler} style={{backgroundColor: 'red'}}>
          <FaFilePdf/>
          РУКОВОДСТВО ПОЛЬЗОВАТЕЛЯ
        </Button>
        {edu_expert && daysToCommission <= 10 &&
          <p className={styles.notice}>
            Внимание! Экспертная группа ГУК начнёт работу через {daysToCommission} дней.
            <br/>
            После начала работы экспертной группы редактирование портфолио будет недоступно.
            <br/>
            Необходимо проверить и подписать все портфолио, поступившие на проверку.
          </p>
        }
      </Col>
      <RequestForm
        specializations={specializations}
        certificationPeriods={certificationPeriods}
        org={org}
        fullMode={expert || guk}
        organizations={organizations}
        getRequestsList={getRequestsList}
      />
      {loading
          ? <Loader/>
          : !!requestsList && 
              <RequestsTable
                specializations={specializations}
                data={requestsList}
                expert={expert}
                openRequest={openRequest}
              />
      }
    </div>
  )
}
